import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";

export function SettingsNav() {
  const { user } = useAuth();
  const canManageTenant = (user?.permissions || []).includes("settings.view");
  const tabs = [
    canManageTenant && { to: "/settings", label: "Azienda", end: true },
    { to: "/settings/profile", label: "Profilo" },
    { to: "/settings/security", label: "Sicurezza" },
  ].filter(Boolean);
  return (
    <div className="mb-6 flex gap-1 overflow-x-auto border-b border-border" data-testid="settings-nav">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.end}
          className={({ isActive }) => cn("whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors",
            isActive ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground")}>
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
